<template>
  <el-dialog
    title="关联推送"
    :visible.sync="showContentDialog"
    width="fit-content"
    :modal-append-to-body="true"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <div class="relate-push-warapper">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="问卷" name="first"> </el-tab-pane>
        <el-tab-pane label="健康宣教" name="second"> </el-tab-pane>
        <el-tab-pane label="培训教程" name="third"> </el-tab-pane>
      </el-tabs>
      <div style="height:640px">
        <addQuestionContent
          v-show="showAddQuestion"
          :notDisplayQuestionList="notDisplayQuestionList"
          :isRelatePush="true"
          :showDiffQS="true"
          :dialogTitle="''"
          :showAddQuestion.sync="showAddQuestion"
          @receiveQuestion="receiveQuestion"
        />
        <healthEducationArticle
          v-show="showHealthy"
          :notDisplayArticleArr="notDisplayArticleArr"
          :isRelatePush="true"
          :showHealthy.sync="showHealthy"
          @receiveArticle="receiveArticle"
        />
        <addtrainingTutorial
          v-if="showTutorial"
          :isRelatePush="true"
          @receiveTutorial="receiveTutorial"
        ></addtrainingTutorial>
      </div>
    </div>
    <!-- <div class="total-content-row">
      已选 问卷<span>{{ questionData.length }}</span
      >条；宣教<span>{{ articleData.length }}</span
      >条；培训教程<span>{{ selectTotal.length }}</span
      >条；
    </div> -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="medium" @click="confirmSubmit">确定，提交</el-button>
    </span>
  </el-dialog>
</template>
<script>
import addQuestionContent from "@/views/ToolMaintenance/component/addQuestionContent";
import healthEducationArticle from "@/views/ToolMaintenance/component/healthEducationArticle";
import addtrainingTutorial from "@/views/ToolMaintenance/component/addtrainingTutorial";

export default {
  name: "RelatePushDialog",
  props: {
    notDisplayQuestionList: {
      type: Array,
      default: () => []
    },
    notDisplayArticleArr: {
      type: Array,
      default: () => []
    },
    showContentDialog: {
      type: Boolean
    },
    chapterId: {
      type: String
    }
  },
  components: {
    addQuestionContent,
    healthEducationArticle,
    addtrainingTutorial
  },
  data() {
    return {
      activeName: "first",
      showAddQuestion: true,
      showHealthy: false,
      showTutorial: false,
      questionData: [],
      articleData: [],
      //   addtrainingTutorial: [],
      addtrainingTutorial: this.$store.state.chapterArr, //所有选中的章节

      //   selectTotal: [],//统计教程数据
      selectTotal: []
    };
  },
  created() {
    this.selectTotal = this.getSortList(this.$store.state.chapterArr);
    if (this.$store.state.courseId != null) {
      this.activeName = "third";
      this.showHealthy = false;
      this.showAddQuestion = false;
      this.showTutorial = true;
    }
  },
  mounted() {},
  methods: {
    confirmSubmit() {
      this.questionData = this.questionData.map((item, index) => {
        delete item.createUserId;
        delete item.createTime;
        return {
          pushRefName: item.title,
          pushRefId: item.id,
          pushType: 1,
          ...item
        };
      });
      this.articleData = this.articleData.map((item, index) => {
        delete item.createUserId;
        delete item.createTime;
        return {
          pushRefName: item.title,
          pushRefId: item.id,
          pushType: 3,
          ...item
        };
      });
      this.addtrainingTutorial = this.addtrainingTutorial.map((item, index) => {
        delete item.createUserId;
        delete item.createTime;
        // item.courseName = '身体康复训练指南测试测算'
        return {
          pushRefName: item.courseName || item.pushRefName,
          pushRefId: item.id || item.pushRefId,
          pushType: 4,
          ...item
        };
      });
      this.$emit(
        "receivePushData",
        this.questionData,
        this.articleData,
        this.addtrainingTutorial
      );
      this.$emit("update:showContentDialog", false);
    },
    receiveQuestion(data) {
      this.questionData = data;
    },
    receiveArticle(data) {
      this.articleData = data;
    },
    receiveTutorial(data) {
      this.selectTotal = data.selectTotal;
      this.addtrainingTutorial = data.selectAll;
    },
    handleClose() {
      this.$emit("update:showContentDialog", false);
    },
    handleTabClick() {
      if (this.activeName == "first") {
        this.showHealthy = false;
        this.showAddQuestion = true;
        this.showTutorial = false;
      }
      if (this.activeName == "second") {
        this.showHealthy = true;
        this.showAddQuestion = false;
        this.showTutorial = false;
      }
      if (this.activeName == "third") {
        this.showHealthy = false;
        this.showAddQuestion = false;
        this.showTutorial = true;
      }
    },
    getSortList(list) {
      const map = new Map();
      list.forEach((item, index, arr) => {
        if (!map.has(item.courseName)) {
          map.set(
            item.courseName,
            arr.filter(a => a.courseName == item.courseName)
          );
        }
      });
      return Array.from(map).map(item => [...item[1]]);
    }
  }
};
</script>
<style lang="less" scoped>

/deep/.el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
.relate-push-warapper {
  height: 740px;
}
.total-content-row {
  span {
    color: #1a7bfc !important;
  }
}
/deep/.el-dialog__footer {
  // margin-top: 10px;
  text-align: center;
}
</style>
<style lang="less">
.relate-push-warapper {
  .el-tabs {
    padding: 0 19px;
  }
  .el-tabs__header {
    margin-bottom: 10px;
  }
  .el-tabs__item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #333333;
  }
  .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
}
</style>
